import type { IAccessRoleRepository } from '../../domain/repositories/IAccessRoleRepository';
import { CompositeAccessRoleRepository } from './CompositeAccessRoleRepository';

let instance: IAccessRoleRepository | null = null;

export function getAccessRoleRepository(): IAccessRoleRepository {
  if (!instance) {
    instance = new CompositeAccessRoleRepository();
  }
  return instance;
}
